import React, { useState } from "react";
import { Box, Grid2, useTheme, useMediaQuery, Typography, Modal, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { galleryImages } from "../images";

function Gallery() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      src: galleryImages.IMG_9958,
      size: { xs: 12, sm: 8 },
    },
    {
      src: galleryImages.IMG_9977,
      size: { xs: 12, sm: 4 },
    },
    {
      src: galleryImages.IMG_9981,
      size: { xs: 12, sm: 6 },
    },
    {
      src: galleryImages.IMG_9986,
      size: { xs: 12, sm: 6 },
    },
    {
      src: galleryImages.IMG_9988,
      size: { xs: 12, sm: 12 },
    },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        background: "rgb(0, 0, 0)",
        overflowY: "auto",
        px: 1, 
        pb:3, 
      }}
    >
      <Box sx={{ height: "30%", pt: 3, pb: 3, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <Typography variant="h2" sx={{ color: "white", textAlign: "center", lineHeight: "1.2" }}>Thank you!</Typography>
        <Typography variant="h2" sx={{ color: "white", textAlign: "center", lineHeight: "1.2" }}>We can't wait to celebrate with you.</Typography>
        <Typography variant="h2" sx={{ color: "white", textAlign: "center", lineHeight: "1.2" }}>If you have any dietary requirements please send us an email at joeandachsa@gmail.com</Typography>
      </Box>
      <Grid2 
        container 
        spacing={2}
        sx={{
          width: "100%",
        }}  
      >
        {images.map((image, index) => (
          <Grid2  
            key={index} 
            size={{...image.size}}
            sx={{ display: "flex", width: "100%" }}
          >
            <Box
              onClick={() => setSelectedImage(image)}
              sx={{
                position: "relative",
                paddingTop: isMobile ? "100%" : "75%",
                width: "100%",
                overflow: "hidden",
                borderRadius: 2,
                cursor: "pointer",
                "&:hover img": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <img
                src={image.src}
                alt={`Gallery ${index + 1}`}
                onError={(e) => console.error('Image failed to load:', e.target.src)}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.3s ease-in-out",
                  WebkitUserDrag: "none",
                  KhtmlUserDrag: "none",
                  MozUserDrag: "none",
                  OUserDrag: "none",
                  userDrag: "none",
                  WebkitTouchCallout: "none",
                }}
                loading="lazy"
                draggable={false}
              />
            </Box>
          </Grid2>
        ))}
      </Grid2>

      {/* Image Preview Modal */}
      <Modal
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgb(0, 0, 0)',
        }}
      >
        <Box sx={{ width: '100vw', height: '100vh', position: 'relative' }}>
          <IconButton
            onClick={() => setSelectedImage(null)}
            sx={{
              position: 'fixed',
              top: 16,
              right: 16,
              color: 'white',
              background: 'rgba(0, 0, 0, 0.3)',
              '&:hover': {
                background: 'rgba(0, 0, 0, 0.5)',
              },
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {selectedImage && (
              <img
                src={selectedImage.src}
                alt="Preview"
                style={{
                  maxHeight: '100vh',
                  maxWidth: '100vw',
                  objectFit: 'contain',
                }}
              />
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default Gallery;
